<template>
  <div class="card card-content">
    <div class="card-header">
      <div class="header">
        <div class="breadcrumb">
          <a class="breadcrumb-item" v-link="/">Accueil</a>
          <a class="breadcrumb-item" v-link="/contact/list">Gestion des participants</a>
          <a class="breadcrumb-item" v-link="{ name: 'editContact', params: { contactId: this.contact.id } }">{{ name }}</a>
          <a class="breadcrumb-item" v-link="{ name: 'editContact.cers', params: { contactId: this.contact.id } }">CER</a>
        </div>
        <h1>{{ contact.leader_firstname }} {{ contact.leader_lastname }}</h1>
      </div>
      <div class="actions">
        <a class="btn btn-link" v-link="{ path: '/contact/list' }">Voir tous les participants</a>
        <a class="btn btn-link" v-link="{ name: 'addProjectWithContact', params: { contactId: contact.id } }">Ajouter un parcours</a>
        <a class="btn btn-link" v-link="{ name: 'addMeetingWithContact', params: { contactId: contact.id } }">Ajouter un rdv</a>
      </div>
    </div>
    <div class="card-block">
      <ul class="nav nav-tabs">
        <li class="nav-item">
          <a class="nav-link" v-link="{ name: 'editContact', params: { contactId: contact.id }}">Informations</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" v-link="{ name: 'parcoursContact', params: { contactId: contact.id }}">Parcours</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" v-link="{ name: 'planningContact', params: { contactId: contact.id }}">Planning</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" v-link="{ name: 'editContact.entreprises', params: { contactId: contact.id }}">Entreprises</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" v-link="{ name: 'editContact.emplois', params: { contactId: contact.id }}">Emplois</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" v-link="{ name: 'editContact.formations', params: { contactId: contact.id }}">Formations</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" v-link="{ name: 'editContact.capes', params: { contactId: contact.id }}">CAPE</a>
        </li>
        <li class="nav-item">
          <a class="nav-link active" v-link="{ name: 'editContact.cers', params: { contactId: contact.id }}">CER</a>
        </li>
      </ul>
    </div>
    <div class="card-block">
      <h2 class="card-title">Liste des CER</h2>
      <h4>N° allocation CAF : {{contact.caf_num}}</h4>
      <table class="table table-hover">
        <thead>
        <tr>
          <th>Titre</th>
          <th>&nbsp;</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="cer of cers | orderBy 'title'">
          <td>No : {{ cer.contract_num }} {{ cer.title }} - Début : {{ cer.start_date }} - Fin : {{ cer.end_date }}</td>
          <td class="text-xs-right">
            <button class="btn btn-primary" v-on:click="edit(cer)">Modifier</button>
            <button class="btn btn-warning" v-on:click="remove(cer)">Supprimer</button>
          </td>
        </tr>
        </tbody>
        <tfoot>
        <tr>
          <td colspan="6">
            <button class="btn btn-primary" v-on:click="create()">Créer un CER</button>
          </td>
        </tr>
        </tfoot>
      </table>
    </div>
  </div>
  <div class="card-block" v-if="cer !== null">
    <hr>
    <h2 class="card-title">{{ editionName }}</h2>
    <validator name="validator">
      <form novalidate>
								<div class="col-sm-6">
									<!-- Numéro contrat -->
									<div class="form-group">
											<label for="contract_num">Numéro de contrat</label>
                      <input class="form-control"
                             id                         = "contract_num"
                             type                       = "text"
                             v-model                    = "cer.contract_num"
                      >
									</div>
								</div>   
								<div class="col-sm-6">
									<!-- Libellé du contrat -->
									<div class="form-group">
											<label for="title">Libellé du contrat</label>
                      <input class="form-control"
                             id                         = "title"
                             type                       = "text"
                             v-model                    = "cer.title"
                      >
									</div>
								</div> 
                            <div class="col-sm-6">
                            <!-- Date entree -->
                                <div class="form-group">
                                    <label for="start_date">Date début de CER</label>
                                    <!--
                                    <date-picker
                                        :time.sync = "cer.start_date"
                                        :option    = "datepickerOptions"
                                        :inputClass = "form-control"
                                    ></date-picker>
                                    -->
                                    <input
                                      id               = "start_date"
                                      class            = "form-control"
                                      type             = "text"
                                      v-model          = "cer.start_date"
                                    >
                                    <!--<small class="form-text text-danger" v-if="$validator.start_date.required">Vous devez indiquer une date</small>-->
                                </div>
                            </div>
                            <div class="col-sm-6">
                                <!-- Date fin -->
                                <div class="form-group">
                                    <label for="end_date">Date fin de CER</label>
                                    <!--
                                    <date-picker
                                        :time.sync = "cer.end_date"
                                        :option    = "datepickerOptions"
                                        :inputClass = "form-control"
                                    ></date-picker>
                                    -->
                                    <input
                                      id               = "end_date"
                                      class            = "form-control"
                                      type             = "text"
                                      v-model          = "cer.end_date"
                                    >
                                    <!--<small class="form-text text-danger" v-if="$validator.end_date.required">Vous devez indiquer une date</small>-->
                                </div>
                            </div>
                            <div class="col-sm-6">
                                <!-- Date réception -->
                                <div class="form-group">
                                    <label for="reception_date">Date réception FL</label>
                                    <!--
                                    <date-picker
                                        :time.sync = "cer.reception_date"
                                        :option    = "datepickerOptions"
                                        :inputClass = "form-control"
                                    ></date-picker>
                                    -->
                                    <input
                                      id               = "reception_date"
                                      class            = "form-control"
                                      type             = "text"
                                      v-model          = "cer.reception_date"
                                    >
                                    <!--<small class="form-text text-danger" v-if="$validator.reception_date.required">Vous devez indiquer une date</small>-->
                                </div>
                            </div>
                            <div class="col-sm-12">
                                <!-- Instructeur -->
                                <div class="form-group">
                                    <label for="instructor">Instructeur</label>
                                    <select id="instructor" class="form-control" v-model="cer.instructor_id">
                                      <option value=""></option>
                                      <option v-for="instructeur in instructors" :value="instructeur.id">{{ instructeur.name }}</option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-sm-12">
                                <!-- Autre instructeur -->
                                <div class="form-group">
                                    <label for="instructor_precision">Autre instructeur</label>
                                    <input class="form-control"
                                        id                         = "instructor_precision"
                                        type                       = "text"
                                        v-model                    = "cer.instructor_precision"
                                    >
                                </div>
                            </div>
                            <div class="col-sm-12">
                                <!-- Prescripteur -->
                                <div class="form-group">
                                    <label for="prescriptor">Prescripteur/SDI</label>
                                    <select id="prescriptor" class="form-control" v-model="cer.prescriptor_id">
                                      <option value=""></option>
                                      <option v-for="prescripteur in prescriptors" :value="prescripteur.id">{{ prescripteur.name }}</option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-sm-12">
                                <!-- Autre Prescripteur -->
                                <div class="form-group">
                                    <label for="prescriptor_precision">Autre Prescripteur</label>
                                    <input class="form-control"
                                        id                         = "prescriptor_precision"
                                        type                       = "text"
                                        v-model                    = "cer.prescriptor_precision"
                                    >
                                </div>
                            </div>
                            <div class="col-sm-12">
                                <!-- Référent -->
                                <div class="form-group">
                                    <label for="referent_adviser">Référent unique</label>
                                    <input class="form-control"
                                        id                         = "referent_adviser"
                                        type                       = "text"
                                        v-model                    = "cer.referent_adviser"
                                    >
                                </div>
                            </div>
                            <div class="col-sm-6">
                              <!-- Phone RU -->
                              <div class="form-group">
                                <label for="phone_referent_adviser">Téléphone RU</label>
                                <input class="form-control"
                                       id="phone_referent_adviser"
                                       type="text"
                                       v-model="cer.phone_referent_adviser"
                                       v-validate:phone_referent_adviser="validationRules.phone_referent_adviser"
                                >
                                <small class="form-text text-danger" v-if="$validator.phone_referent_adviser.validatePhone">Vous devez indiquer un
                                  téléphone valide
                                </small>
                              </div>
                            </div>
                            <div class="col-sm-6">
                              <!-- Email RU-->
                              <div class="form-group">
                                <label for="email_referent_adviser">Email RU</label>
                                <input class="form-control"
                                       id="email_referent_adviser"
                                       type="text"
                                       v-model="cer.email_referent_adviser"
                                       v-validate:email_referent_adviser="validationRules.email_referent_adviser">
                                <small class="form-text text-danger" v-if="$validator.email_referent_adviser.validateEmail">L'adresse email fournie n'est pas valide</small>
                              </div>
                            </div>
        <div class="col-sm-12">
          <label for="observations">Observations</label>
          <textarea class="form-control" rows="6" cols="40" id="observations" v-model="cer.observations"></textarea>
        </div>
        <div class="col-sm-12">
          <div class="text-xs-right">
            <button class="btn btn-default" v-on:click.prevent="cancel()">Fermer</button>
            <button class="btn btn-primary" v-on:click.prevent="save()" :class="{ disabled: !$validator.valid }">Enregistrer</button>
          </div>
          </div>
      </form>
    </validator>
  </div>
</template>
<script>
    // Required for datepicker
    import moment from 'moment'

    // Options for datepicker
    import { datepickerOptions } from 'src/options/date'

    // Required for datepicker
    import datePicker from 'vue-datepicker/vue-datepicker-1.vue'
    import { Switch } from 'mint-ui'

    // Vuex
    import { getCers, addCer, editCer, deleteCer } from 'src/vuex/actions/cerActions'
    import { getContact } from 'src/vuex/actions/contactActions'
    import { getInstructors } from 'src/vuex/actions/instructorsActions'
    import { getPrescriptors } from 'src/vuex/actions/prescriptorsActions'
    import {
        contact,
        // cer,
        instructors,
        prescriptors,
        cers,
        cerRequestError as requestError
    } from 'src/vuex/getters'

    export default{
      vuex: {
        getters: {
          // cer,
          cers,
          instructors,
          prescriptors,
          requestError,
          contact
        },
        actions: {
          getContact,
          getCers,
          addCer,
          editCer,
          getInstructors,
          getPrescriptors,
          deleteCer
        }
      },
      validators: {
        list: function (val) {
          return /^[1-9]+$/.test(val)
        }
      },
      data () {
        return {
          isHidden: true,
          cer: null,
          cerUpdate: null,
          datepickerOptions
        }
      },
      computed: {
        name: function () {
          if (Number.isInteger(this.contact.id)) {
            return this.contact.leader_firstname + ' ' + this.contact.leader_lastname
          } else {
            return 'Contact'
          }
        },
        editionName: function () {
          return (this.cer !== null && Number.isInteger(this.cer.id)) ? 'Edition' : 'Création'
        }
      },
      methods: {
        edit: function (cer) {
          this.cer = JSON.parse(JSON.stringify(cer))
          this.cerUpdate = cer
        },
        remove: function (cer) {
          this.deleteCer(cer)
          let that = this
          setTimeout(function () { that.cer = null }, 1000)
        },
        create: function () {
          this.cer = {}
          this.cerUpdate = null
        },
        cancel: function () {
          this.cer = null
          this.cerUpdate = null
        },
        save: function () {
          if (this.cer !== null) {
            if (typeof (this.cer.start_date) === 'undefined' || this.cer.start_date === null || this.cer.start_date === '' || this.cer.start_date === 'undefined' || this.cer.start_date === 'Invalid date') {
              this.cer.start_date = ''
            } else {
              this.cer.start_date = moment(this.cer.start_date, 'DD/MM/YYYY').format('DD-MM-YYYY')
            }
            if (typeof (this.cer.end_date) === 'undefined' || this.cer.end_date === null || this.cer.end_date === '' || this.cer.end_date === 'undefined' || this.cer.end_date === 'Invalid date') {
              this.cer.end_date = ''
            } else {
              this.cer.end_date = moment(this.cer.end_date, 'DD/MM/YYYY').format('DD-MM-YYYY')
            }
            if (typeof (this.cer.reception_date) === 'undefined' || this.cer.reception_date === null || this.cer.reception_date === '' || this.cer.reception_date === 'undefined' || this.cer.reception_date === 'Invalid date') {
              this.cer.reception_date = ''
            } else {
              this.cer.reception_date = moment(this.cer.reception_date, 'DD/MM/YYYY').format('DD-MM-YYYY')
            }
            if (Number.isInteger(this.cer.id) === true) {
              this.editCer(this.cerUpdate, this.cer)
            } else {
              this.cer.contact_id = this.contact.id
              this.addCer(this.cer)
            }

            if (this.error === false) {
              this.cer = null
            }
            let contactId = this.contact.id
            let that = this
            setTimeout(function () { that.cer = null; that.getCers(contactId) }, 1000)
          }
        }
      },
      components: { 'date-picker': datePicker, Switch },
      ready () {
	/*
        this.getInstructors().then(function () {
          this.originInstructors.forEach(function (element) {
            this.instructors[element.id] = element.name
          })
        })
        this.getPrescriptors().then(function () {
          this.originPrescriptors.forEach(function (element) {
            this.prescriptors[element.id] = element.name
          })
        })
	*/
        this.$dispatch('preview-data', [])
        this.getInstructors()
        this.getPrescriptors()
        this.getContact(this.$route.params.contactId)
        this.getCers(this.$route.params.contactId)
      }
    }
</script>



// WEBPACK FOOTER //
// ContactEditCers.vue?12263011